import { flowConstants } from '../constants';
import { flowService } from '../services';
import { handleErrors } from '../../utils';
import { loaderMaskActions } from '.';

export const flowActions = {
  getEventGroupTree,
  toggleActiveTab,
  setSelectedNode
};

function setSelectedNode(node) {
  return { type: flowConstants.SET_SELECTED_NODE, node };
}

function toggleActiveTab(tab) {
  return { type: flowConstants.TOGGLE_ACTIVE_TAB, tab };
}

function getEventGroupTree(params) {
  return dispatch => {
    dispatch(loaderMaskActions.show('Loading events...'));
    dispatch(request());
    return flowService.getEventGroupTree(params).then(
      data => {
        dispatch(loaderMaskActions.hide(''));
        return dispatch(success(data, params));
      },
      error => {
        handleErrors(error, dispatch);
        dispatch(loaderMaskActions.hide(''));
        return dispatch(failure(error));
      }
    );
  };
  function request() {
    return { type: flowConstants.GET_REQUEST };
  }
  function success(data, params) {
    return { type: flowConstants.GET_EVENT_GROUP_TREE_SUCCESS, data, params };
  }
  function failure(error) {
    return { type: flowConstants.GET_EVENT_GROUP_TREE_FAILURE, error };
  }
}
